import { useSelector } from 'react-redux';
import { listHas } from './rolePermissions';

// Hook: read the current admin's effective permissions and test against them.
export const usePermissions = () => {
  const permissions = useSelector((s) => s.auth.permissions) || [];

  const has = (permission) => !permission || listHas(permissions, permission);
  const hasAny = (perms = []) => perms.some((p) => has(p));
  const hasAll = (perms = []) => perms.every((p) => has(p));

  return { permissions, has, hasAny, hasAll };
};

export default usePermissions;
